<div class="cash-flow-statement-compare">
  <klt-section
    title="Cash flow statement"
    type="button"
    buttonText="COMPARE"
    (buttonClick)="handleClick()"
  >
  </klt-section>
</div>
